<template>
  <v-app>
    <v-container>
      <v-row
        class="d-flex"
      >
        <v-card
          class="mx-auto px-2"
          style="max-width: 95%"
        >
          <v-card
            flat
            class="card-full-width section-header mt-0 pt-0"
          >
            Register an account
          </v-card>
          <v-card
            flat
            class="mt-0"
          >
            <v-form
              ref="form"
            >
              <v-row>
                <v-col
                  cols="6"
                  md="6"
                >
                  <v-text-field
                    v-model="form.first_name"
                    :rules="[rules.required]"
                    type="text"
                    name="input-10-1"
                    label="First Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.last_name"
                    :rules="[rules.required]"
                    type="text"
                    name="input-10-1"
                    label="Last Name"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-row
                    class="mt-n4"
                  >
                    <v-col
                      cols="12"
                      md="6"
                      class="mt-n2"
                    >
                      <v-text-field
                        ref="userEmailAddress"
                        v-model="form.email_address"
                        :error="emailValidation.error"
                        :success="emailValidation.success"
                        :messages="emailValidation.messages"
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Email
                          </div>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="6"
                      md="3"
                      class="mt-n2"
                    >
                      <v-text-field
                        v-model="form.code_mail"
                        name="code"
                        :success="emailCodeValidation.success"
                        :error="emailCodeValidation.error"
                        :messages="emailCodeValidation.messages"
                        aria-autocomplete="none"
                        placeholder="Code"
                        value=""
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Email Code
                          </div>
                        </template>
                        <template v-slot:append>
                          <v-icon
                            v-if="form.email_verified"
                            color="success"
                          >
                            mdi-check
                          </v-icon>
                          <v-icon
                            v-else
                            color="warning"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="6"
                      md="3"
                      class="mt-n2"
                    >
                      <v-chip
                        v-if="emailCodeValidation.success"
                        color="success"
                      >
                        Verified
                      </v-chip>
                      <v-btn
                        v-else
                        color="info"
                        block
                        tile
                        :disabled="emailCodeValidation.success"
                        @click="doRetrieveEmailCode"
                      >
                        Send Email Code
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n2"
                    >
                      <v-checkbox
                        v-model="form.opt_in_email"
                        label="Opt-in receive Email alerts and messages"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="6"
                  class="mt-n2"
                >
                  <v-text-field
                    v-model="form.password"
                    :success="passwordMatch.success"
                    :error="passwordMatch.error"
                    :messages="passwordMatch.messages"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    counter
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="6"
                  class="mt-n2"
                >
                  <v-text-field
                    v-model="form.confirm_password"
                    :success="passwordMatch.success"
                    :error="passwordMatch.error"
                    :messages="passwordMatch.messages"
                    type="password"
                    name="input-10-1"
                    label="Confirm Password"
                    counter
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  class="mt-n2"
                >
                  <v-checkbox
                    v-model="form.opt_in_sms"
                    label="Opt-in to receive SMS notifications. Standard data and messaging rates may apply."
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-alert
                    v-if="formErrors.length > 0"
                    class="warning"
                  >
                    <v-list
                      class="warning"
                    >
                      <v-list-item
                        v-for="(error, i) in formErrors"
                        :key="'error-' + i"
                      >
                        <v-icon
                          large
                          dark
                          class="mr-2"
                        >
                          mdi-information
                        </v-icon>
                        <span class="formError">{{ error }}</span>
                      </v-list-item>
                    </v-list>
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
          <v-card
            class="d-flex mt-n7"
            flat
          >
            <v-btn
              block
              tile
              color="success"
              class="mr-4"
              @click="submitForm"
            >
              Register
            </v-btn>
          </v-card>
          <v-overlay :value="formOverlay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { PUBLIC_IS_EMAIL_UNIQUE, PUBLIC_REGISTER_USER, AUTH_LOGIN } from '../../store/actions.types'

  export default {
    name: 'Login',

    components: {
    },

    data: () => ({
      showPassword: false,
      isLoggingInManual: false,
      expandOnHover: false,
      formOverlay: false,
      form: {
        email_address: '',
        password: '',
        confirm_password: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        opt_in_sms: false,
        opt_in_email: false,
        code_mail: '',
      },
      emailValidation: {
        error: false,
        success: false,
        messages: '',
      },
      emailCodeValidation: {
        error: false,
        success: false,
        messages: '',
      },
      passwordMatch: {
        error: false,
        success: false,
        messages: '',
      },
      formErrors: [],
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },

    }),
    computed: {
      ...mapGetters(['isLoggedIn']),
    },
    watch: {
      isLoggedIn (n, o) {
        if (n) {
          this.$router.push('/app')
        }
      },
      'form.email_address' (n, o) {
        this.doVerifyEmailUnique(n)
      },
      'form.code_mail' (n, o) {
        this.onEmailCodeChange(n)
      },
      'form.password' (n, o) {
        console.log('form.password has changed')
        this.onPasswordChange()
      },
      'form.confirm_password' (n, o) {
        console.log('form.confirm_password has changed')
        this.onPasswordChange()
      },
    },
    methods: {
      ...mapActions(['getMobileVerificationCode', 'getEmailVerificationCode', 'verifyEmail', 'verifyMobile']),
      ...mapActions({
        doRegisterUser: PUBLIC_REGISTER_USER,
        doIsEmailUnique: PUBLIC_IS_EMAIL_UNIQUE,
        login: AUTH_LOGIN,
      }),
      async doLogin () {
        console.log('doing login!')
        await this.login({ email_address: this.form.email_address, password: this.form.password })
      },
      async doRegister () {
        this.formOverlay = true
        console.log('doing register!')
        try {
          const data = await this.doRegisterUser(this.form)
          if (data && data.rowkey) {
            this.doLogin()
          }
        } catch (e) {

        }
        this.formOverlay = false
      },
      async onEmailCodeChange (event) {
        console.log(event)
        const payload = { contact: this.form.email_address, code: event }
        const resp = await this.verifyEmail(payload)
        // eslint-disable-next-line camelcase
        const { code } = resp
        // eslint-disable-next-line camelcase
        this.emailCodeValidation.success = code === event
        this.emailCodeValidation.error = code !== event
        console.log(resp)
      },
      onPasswordChange () {
        if (this.form.password === this.form.confirm_password) {
          this.passwordMatch.error = false
          this.passwordMatch.success = true
          this.passwordMatch.messages = []
        } else {
          this.passwordMatch.error = true
          this.passwordMatch.success = false
          this.passwordMatch.messages = 'Passwords must match'
        }
      },
      async doRetrieveEmailCode () {
        const result = await this.getEmailVerificationCode(this.form.email_address)
        if (result.code && result.code.length > 0) {
          alert(`An email has been sent to ${this.form.email_address}`)
        } else {
          alert(`An error occured when sending an email to ${this.form.email_address}`)
        }
      },
      async doVerifyEmailUnique (value) {
        console.log(`New Email Value to verify ${value}`)
        this.emailValidation.error = false
        this.emailValidation.success = false
        const isValidEmail = this.validateEmail(value)
        if (!isValidEmail) {
          this.emailValidation.error = true
          this.emailValidation.success = false
          this.emailValidation.messages = 'Please enter a valid email'
          return
        }
        const isUnique = await this.doIsEmailUnique({ email_address: value })
        if (!isUnique) {
          console.log('isUnique result:', isUnique)
          console.log('email already in use result:')
          this.emailValidation.error = true
          this.emailValidation.success = false
          this.emailValidation.messages = 'Email already in use'
        } else {
          console.log('isUnique result:', isUnique)
          console.log('email available:')
          this.emailValidation.error = false
          this.emailValidation.success = true
          this.emailValidation.messages = 'Email available'
          this.formErrors = []
        }
      },
      validateEmail (email) {
        // eslint-disable-next-line no-useless-escape
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(email).toLowerCase())
      },
      async submitForm () {
        this.formErrors = []
        await this.doVerifyEmailUnique(this.form.email_address)
        if (!this.emailValidation.success) {
          this.formErrors.push(this.emailValidation.messages)
          console.log('The email address was not found to be valid')
        }
        if (!this.passwordMatch.success) {
          this.formErrors.push(this.passwordMatch.messages)
          console.log('The the passwordMatch is not valid')
        }
        const formValid = this.$refs.form.validate()
        if (!formValid || this.formErrors.length > 0) {
          console.log('There was an error on the form, not registering the new user.')
          return
        }
        this.doRegister()
      },
    },
    mounted () {
      if (this.isLoggedIn) {
        this.$router.push('/')
      }
    },
  }
</script>

<style scoped>
  .v-alert .v-alert__wrapper .v-alert__content span {
    font-size: 14px;
    font-weight: 500;
    color: white;
  }
</style>
